import { accountTypesOptions } from '../../../shared/data/clientDetailsOptions';

export const mainStateData = {
    name: '',
    client_uid: '',
    api_url: '',
    crm_url: '',
    countries_localizations: {
        sv: {
            company_name: '',
            service_name: '',
            title_service_name: '',
            company_full_name: '',
        },
        no: {
            company_name: '',
            service_name: '',
            title_service_name: '',
            company_full_name: '',
        },
        fi: {
            company_name: '',
            service_name: '',
            title_service_name: '',
            company_full_name: '',
        },
        da: {
            company_name: '',
            service_name: '',
            title_service_name: '',
            company_full_name: '',
        },
        en: {
            company_name: '',
            service_name: '',
            title_service_name: '',
            company_full_name: '',
        },
        is: {
            company_name: '',
            service_name: '',
            title_service_name: '',
            company_full_name: '',
        },
    },
    database_name: '',
    database_host: '',
    database_user_name: '',
    database_password: '',
    is_email_required: 0,
    is_ssn_required: 0,
    is_send_sms_if_phone_not_confirmed: 0,
    theme_id: null,
};

export const dataStoreData = {
    api_url: '',
    ssn_required: null,
    email_required: null,
    is_criipto_integration_enabled: false,
    is_bank_id_login_enabled: false,
    is_login_email_form_enabled: true,
    is_show_powered_by_defentry_logo: false,
    criipto_methods: null,
    criipto_buttons_styles: 'default',
    is_2fa_enabled: false,
    welcome_priority: 'email',
    retention_send_out: false,
    show_ssn_in_crm: false,
    monthly_email: false,
    max_employee_values: [0],
    max_members_values: [0],
    company_info: {
        se: {
            company_name: '',
            service_name: '',
            company_full_name: '',
        },
        no: {
            company_name: '',
            service_name: '',
            company_full_name: '',
        },
        fi: {
            company_name: '',
            service_name: '',
            company_full_name: '',
        },
        dk: {
            company_name: '',
            service_name: '',
            company_full_name: '',
        },
        is: {
            company_name: '',
            service_name: '',
            company_full_name: '',
        },
    },
    account_types: accountTypesOptions.map((el) => el.id),
    logos_sizes: {
        web_app: {
            logo: {
                se: { width: '', height: '' },
                no: { width: '', height: '' },
                fi: { width: '', height: '' },
                dk: { width: '', height: '' },
                is: { width: '', height: '' },
            },
            // mark: {...},
            // email: {...},
            // favicon: {...},
        },
        crm: {
            logo: {
                width: '',
                height: '',
            },
            // mark: {...},
            // email: {...},
            // favicon: {...},
        },
    },
    white_label_colors: {
        email_button_content: {
            hover: 'FFFFFF',
            default: 'FFFFFF',
            active: 'FFFFFF',
        },
        primary_button: {
            hover: '2F1FD1',
            default: '3A29E8',
            outlined: false,
            active: '2013AC',
        },
        secondary_button_content: {
            hover: 'FFFFFF',
            default: '2F1FD1',
            active: 'FFFFFF',
        },
        secondary_button: {
            hover: '2F1FD1',
            default: 'FFFFFF',
            outlined: false,
            active: '2013AC',
        },
        email_button: {
            hover: '2F1FD1',
            default: '3A29E8',
            outlined: false,
            active: '2013AC',
        },
        graphic_colors: {
            default: '602DF3',
            light: '716FF4',
            dark: '230F5B',
        },
        links: {
            hover: '3A29E8',
            default: '2013AC',
            underlined: true,
            active: '5948FF',
        },
        primary_button_content: {
            hover: 'FFFFFF',
            default: 'FFFFFF',
            active: 'FFFFFF',
        },
        icons: {
            hover: '3F2DF3',
        },
        selectors: {
            active: '3A29E8',
        },
    },
    countries_localizations: {
        se: {
            web_site_url: '',
            terms_conditions_url: '',
            support_page_url: '',
            blog_page_url: '',
            privacy_policy_url: '',
            web_app_url: '',
            crm_url: '',
            facebook_url: '',
            app_store_url: '',
            google_play_url: '',
            twitter_url: '',
            linkedIn_url: '',
            contact_us_url: '',
            contact_us_email: '',
            instagram_url: '',
            youtube_url: '',
        },
        no: {
            web_site_url: '',
            terms_conditions_url: '',
            support_page_url: '',
            blog_page_url: '',
            privacy_policy_url: '',
            web_app_url: '',
            crm_url: '',
            facebook_url: '',
            app_store_url: '',
            google_play_url: '',
            twitter_url: '',
            linkedIn_url: '',
            contact_us_url: '',
            contact_us_email: '',
            instagram_url: '',
            youtube_url: '',
        },
        fi: {
            web_site_url: '',
            terms_conditions_url: '',
            support_page_url: '',
            blog_page_url: '',
            privacy_policy_url: '',
            web_app_url: '',
            crm_url: '',
            facebook_url: '',
            app_store_url: '',
            google_play_url: '',
            twitter_url: '',
            linkedIn_url: '',
            contact_us_url: '',
            contact_us_email: '',
            instagram_url: '',
            youtube_url: '',
        },
        dk: {
            web_site_url: '',
            terms_conditions_url: '',
            support_page_url: '',
            blog_page_url: '',
            privacy_policy_url: '',
            web_app_url: '',
            crm_url: '',
            facebook_url: '',
            app_store_url: '',
            google_play_url: '',
            twitter_url: '',
            linkedIn_url: '',
            contact_us_url: '',
            contact_us_email: '',
            instagram_url: '',
            youtube_url: '',
        },
        is: {
            web_site_url: '',
            terms_conditions_url: '',
            support_page_url: '',
            blog_page_url: '',
            privacy_policy_url: '',
            web_app_url: '',
            crm_url: '',
            facebook_url: '',
            app_store_url: '',
            google_play_url: '',
            twitter_url: '',
            linkedIn_url: '',
            contact_us_url: '',
            contact_us_email: '',
            instagram_url: '',
            youtube_url: '',
        },
    },
};

export const logosStateData = {
    sv: {
        bigLogo: { logoUrl: '', logoData: null },
        smallLogo: { logoUrl: '', logoData: null },
        favicon: { logoUrl: '', logoData: null },
        emailLogo: { logoUrl: '', logoData: null },
    },
    no: {
        bigLogo: { logoUrl: '', logoData: null },
        smallLogo: { logoUrl: '', logoData: null },
        favicon: { logoUrl: '', logoData: null },
        emailLogo: { logoUrl: '', logoData: null },
    },
    fi: {
        bigLogo: { logoUrl: '', logoData: null },
        smallLogo: { logoUrl: '', logoData: null },
        favicon: { logoUrl: '', logoData: null },
        emailLogo: { logoUrl: '', logoData: null },
    },
    da: {
        bigLogo: { logoUrl: '', logoData: null },
        smallLogo: { logoUrl: '', logoData: null },
        favicon: { logoUrl: '', logoData: null },
        emailLogo: { logoUrl: '', logoData: null },
    },
    is: {
        bigLogo: { logoUrl: '', logoData: null },
        smallLogo: { logoUrl: '', logoData: null },
        favicon: { logoUrl: '', logoData: null },
        emailLogo: { logoUrl: '', logoData: null },
    },
};

export const logosErrors = {
    sv: {
        bigLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        smallLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        faviconErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        emailLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
    },
    no: {
        bigLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        smallLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        faviconErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        emailLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
    },
    fi: {
        bigLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        smallLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        faviconErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        emailLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
    },
    da: {
        bigLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        smallLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        faviconErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        emailLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
    },
    is: {
        bigLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        smallLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        faviconErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
        emailLogoErrors: {
            isWrongFileType: false,
            isFileOversized: false,
        },
    },
};
